
import {useEffect, useReducer} from 'react';

import {DateSlot, TimeSlot} from './types';

type State = {
	dateSlots: DateSlot[]
	date?: DateSlot
	time?: TimeSlot
	automatic?: boolean
};

export type Callbacks = {
	onDate?: (d: DateSlot) => void
	onTime?: (t: TimeSlot) => unknown
}

type Action =
  | { type: 'SET-SLOTS', slots: DateSlot[] }
  | { type: 'SET-DATE', date: DateSlot, automatic?: boolean }
  | { type: 'SET-TIME', time?: TimeSlot };

const reducer = (state: State, action: Action): State => {
	switch (action.type) {
	case 'SET-SLOTS':
		return {
			...state,
			dateSlots: [...action.slots],
		};

	case 'SET-DATE':
		return {
			...state,
			date: action.date,
			time: undefined,
			automatic: action.automatic,
		};

	case 'SET-TIME':
		return {
			...state,
			time: action.time,
			automatic: false,
		};

	default:
		return {...state};
	}
};

export const useState = ({onDate, onTime}: Callbacks) => {
	const result = useReducer(reducer, {dateSlots: []});
	const [state, dispatch] = result;

	// Set up useEffects to handle callbacks; this keeps
	// reducer state simple & clean (vs calling from reducer)
	{
		useEffect(() => {
			if (onDate && state.date) {
				onDate(state.date);
			}
		}, [state.date]);

		useEffect(() => {
			if (!onTime || !state.time) {
				return;
			}

			// Use return value of onTime to determine
			// if we should keep it "set" or auto-unset
			const keep = onTime(state.time);
			if (keep === false) {
				dispatch({type: 'SET-TIME', time: undefined});
			}
		}, [state.time]);
	}

	return result;
};
